import { CreateSessionRequest } from '../contracts/CreateSessionRequest';
import { CreateInviteeRequest } from '../contracts/CreateInviteeRequest';
import { UpdateSessionRequest } from '../contracts/UpdateSessionRequest';
import { Session } from '../models/Session';
import { Invitee } from '../models/Invitee';

export class SessionRequestMapper {
  /**
   * Converts a Session model to a CreateSessionRequest
   * @param model - The session model to convert
   * @returns The converted CreateSessionRequest
   */
  toCreateSessionRequest = (model: Session): CreateSessionRequest => {
    return {
      paymentActivityTypeRequest: model.paymentActivityType,
      title: model.title,
      description: model.description,
      dateStart: new Date(model.dateStart).toISOString(),
      timeLocal: model.timeLocal,
      timeZone: model.timeZone,
      duration: model.duration,
      isAllDay: model.isAllDay,
      recurrenceTypeRequest: model.recurrenceType,
      recurrenceDays: model.recurrenceDays,
      recurrenceDaysNumber: model.recurrenceDaysNumber,
      recurrenceDateEnd: model.recurrenceDateEnd?.toISOString(),
      finishAfterOccurrences: model.finishAfterOccurrences,
      remindBefore: model.remindBefore,
      invitees: model.invitees.map(this.toCreateInviteeRequest)
    };
  };

  /**
   * Converts a Session model to an UpdateSessionRequest
   * @param model - The session model to convert
   * @returns The converted UpdateSessionRequest
   */
  toUpdateSessionRequest = (model: Partial<Session>): UpdateSessionRequest => {
    return {
      paymentActivityTypeRequest: model.paymentActivityType,
      title: model.title,
      description: model.description,
      dateStart: model.dateStart ? new Date(model.dateStart).toISOString() : undefined,
      timeLocal: model.timeLocal,
      timeZone: model.timeZone,
      duration: model.duration,
      isAllDay: model.isAllDay,
      recurrenceTypeRequest: model.recurrenceType,
      recurrenceDays: model.recurrenceDays,
      recurrenceDaysNumber: model.recurrenceDaysNumber,
      recurrenceDateEnd: model.recurrenceDateEnd?.toISOString(),
      finishAfterOccurrences: model.finishAfterOccurrences,
      remindBefore: model.remindBefore
    };
  };

  /**
   * Converts an Invitee model to a CreateInviteeRequest
   * @param model - The invitee model to convert
   * @returns The converted CreateInviteeRequest
   */
  toCreateInviteeRequest = (model: Invitee): CreateInviteeRequest => {
    return {
      invitedUserId: model.invitedUserId,
      typeRequest: model.type
    };
  };
}
